import { LOCALE_SWITCHER_OPTIONS } from "@/utils/localeUtils.js";
import deSvg from "../assets/flags/de.svg";
import eeSvg from "../assets/flags/ee.svg";
import esSvg from "../assets/flags/es.svg";
import fiSvg from "../assets/flags/fi.svg";
import frSvg from "../assets/flags/fr.svg";
import gbSvg from "../assets/flags/gb.svg";
import itSvg from "../assets/flags/it.svg";
import nlSvg from "../assets/flags/nl.svg";
import noSvg from "../assets/flags/no.svg";
import plSvg from "../assets/flags/pl.svg";
import ruSvg from "../assets/flags/ru.svg";
import seSvg from "../assets/flags/se.svg";

const FLAG_MAP = {
  de: deSvg,
  ee: eeSvg,
  es: esSvg,
  fi: fiSvg,
  fr: frSvg,
  gb: gbSvg,
  it: itSvg,
  nl: nlSvg,
  no: noSvg,
  pl: plSvg,
  ru: ruSvg,
  se: seSvg
};

const getFlagSrc = (flagCode) => FLAG_MAP[flagCode] ?? null;

/** Language options for LED bar config and other pickers */
export const languagePickerOptions = LOCALE_SWITCHER_OPTIONS.map((locale) => ({
  label: locale.label,
  value: locale.value,
  flag: getFlagSrc(locale.flag)
}));
